import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import VersionSetItem from './VersionSetItem';
import { FolderUtil } from '../utils';

/**
 * [Model] TransmittalDocumentItem
 */
var TransmittalDocumentItem = /*#__PURE__*/function () {
  function TransmittalDocumentItem() {
    _classCallCheck(this, TransmittalDocumentItem);
  }
  return _createClass(TransmittalDocumentItem, null, [{
    key: "parseV2",
    value:
    /**
     * Parser with camel case data
     *
     * @param data - the object to parse
     */
    function parseV2(data) {
      var rowData = data || {};
      var entity = new TransmittalDocumentItem();
      entity.urn = rowData.urn;
      entity.name = rowData.name;
      entity.title = rowData.title;
      entity.description = rowData.description;
      entity.version = rowData.version;
      entity.fileName = rowData.fileName;
      entity.sets = (rowData.sets || []).filter(function (set) {
        return !!set;
      }).map(function (set) {
        return VersionSetItem.parseV3(set);
      });
      entity.lastUpdated = rowData.lastUpdated;
      entity.updatedBy = rowData.updatedBy;
      entity.updatedUserId = rowData.updatedUserId;
      entity.actions = rowData.actions;
      entity.hidden = rowData.hidden;
      entity.parentFolderUrn = rowData.parentFolderUrn;
      entity.approvalStatus = rowData.approveStatus || {};

      // Localize displayPath if it exists
      if (rowData.displayPath !== undefined) {
        entity.displayPath = FolderUtil.localizeFolderPath(rowData).displayPath;
      }
      return entity;
    }
  }]);
}();
export { TransmittalDocumentItem as default };